import { AccordionProps } from "Componentes/Accordion/AccordionItem";
import GitFlow from "Contents/GitFlow";

export const Tasks: Array<AccordionProps> = [
  {
    answer: "Cloná el repositorio de crombie docs:",
    reply: (
      <p>
        Si todavía no lo hiciste, cloná el repositorio de crombie docs en tu
        computadora para poder empezar a trabajar.
      </p>
    )
  },
  {
    answer: "Agregate a la lista de desarrolladores:",
    reply: (
      <p>
        Vas a ver que en la barra de la izquierda hay un listado de
        desarrolladores. Para agregarte a ese listado, vas a tener que ir a la
        carpeta Developers y crear un archivo "NombreApellido.tsx" que exporte
        por defecto un componente funcional que muestre por pantalla un perfil
        que tenés que crear vos. No hay un estilo especifico que tengas que
        seguir, lo quer quieras poner, y como lo quieras poner, lo decidis vos.
        Como guía, estaría bueno que pongas por lo menos tu nombre, el área en
        la que entras a la empresa, una foto (o un avatar) y una breve
        descripción tuya para que los otros te puedan conocer.
      </p>
    )
  },
  {
    answer: "Creá una rama de tipo feature para agregar estos cambios:",
    reply: (
      <p>
        Una vez que hayas terminado tu perfil, crea una rama de tipo feature/* a
        partir de develop y agregá tus cambios. Si querés podes entrar{" "}
        <a href={`/content/${GitFlow.route}`}>acá</a> para leer un poco sobre
        como manejamos el esquema GitFlow en el equipo de desarrollo de Crombie.
      </p>
    )
  },
  {
    answer: "Creá un pull request a develop:",
    reply: (
      <p>
        Entrá a tu cuenta en{" "}
        <a href='https://bitbucket.org/4rsoluciones/'>Bitbucket</a> y en el
        repositorio de crombie docs creá un Pull Request de la rama que creaste
        en el paso anterior a develop y explicá en el pull request cual fue el
        cambio que realizaste. Ya hay reviewers designados que van a revisar tu
        código.
      </p>
    )
  },
  {
    answer:
      "Si el revisor te pidió cambios, realizalos y actualizá el pull request:",
    reply: (
      <p>
        Puede ser que quien revise el código te pida hacer algunos cambios. Si
        te los pidió, agregá los cambios y actualizá el pull request.
      </p>
    )
  },
  {
    answer:
      "Siguiendo el esquema de Git Flow, agregá tu foto de perfil (o avatar) al home:",
    reply: (
      <p>
        Siguiendo el mismo esquema de trabajo que seguiste en los puntos
        anteriores (crear una rama, hacer cambios, proponer esos cambios en un
        pull request, integrar a develop) agregá tu foto de perfil (o avatar) al
        listado de perfiles que hay en la pantalla del home.
      </p>
    )
  },
  {
    answer: "Subí todo lo que hiciste hasta ahora en un release:",
    reply: (
      <p>
        Luego de que hayan sido aceptados todos los pull request, siguiendo el
        mismo esquema de GitFlow, vas a tener que crear una nueva rama de tipo
        release/* donde tambien vas a tener que subir de versionado en el
        archivo <i>package.json</i>.
      </p>
    )
  },
  {
    answer:
      "Andá al proyecto de crombie docs en Jira y resolvé los issues en los que estés asignado",
    reply: (
      <p>
        En el{``}{" "}
        <a href='https://4r-soluciones.atlassian.net/secure/RapidBoard.jspa?projectKey=CD08806&rapidView=392'>
          {" "}
          proyecto de Crombie docs en Jira{" "}
        </a>
        {``} resolvé los issues en los que estes asignado. Para esto podes
        comentar las tarjetas pidiendo aclaración de lo que tenés que hacer. Si
        resolver la tarjeta implica agregár código al proyecto, tenés que crear
        una rama desde la interfaz en jira (para que la rama quede atada al
        issue).
      </p>
    )
  }
];
